import { action, makeObservable, observable, flow } from "mobx";
import { API } from "aws-amplify";
import { deleteAgent } from "../../../graphql/queries";

class ViewAgentStore {
  searchValue = '';
  statusFilter = [];
  scopeFilter = [];
  modifiedFilter = [];
  categoryFilter = [];
  ownerFilter = [];
  isLoading = false;
  isError = false;
  isConfirm = false;
  itemsPerPage = 9;
  currentPage = 1;
  availablePageSizes = [3, 6, 9, 12];

  constructor() {
    makeObservable(this, {
      searchValue: observable,
      statusFilter: observable,
      scopeFilter: observable,
      modifiedFilter: observable,
      categoryFilter: observable,
      ownerFilter: observable,
      currentPage: observable,
      isLoading: observable,
      isError: observable,
      isConfirm: observable,
      itemsPerPage: observable,
      onHandleSearchChange: action,
      onChangePage: action,
      onClearError: action,
      setStatusFilter: action,
      setScopeFilter: action,
      setModifiedFilter: action,
      setCategoryFilter: action,
      setOwnerFilter: action,
      handleConfirmDelete: flow,
      onChangeItemsPerPage: action,
      clearAllFilters: action,
    });
  }

  onHandleSearchChange = (e) => {
    this.searchValue = e.target.value;
    this.currentPage = 1;
  }

  onChangePage = (_, page) => {
    this.currentPage = page;
  }

  onChangeItemsPerPage = (newSize) => {
    this.itemsPerPage = newSize;
    this.currentPage = 1;
  };

  setStatusFilter = (status) => {
    this.statusFilter = status;
  };

  setScopeFilter = (scope) => {
    this.scopeFilter = scope;
  };

  setModifiedFilter = (filter) => {
    this.modifiedFilter = filter;
  };

  setCategoryFilter = (category) => {
    this.categoryFilter = category;
  };

  setOwnerFilter = (owner) => {
    this.ownerFilter = owner;
  };

  clearAllFilters =() => {
    this.searchValue = '';
    this.statusFilter = [];
    this.scopeFilter = [];
    this.modifiedFilter = [];
    this.categoryFilter = [];
    this.ownerFilter = [];
    this.currentPage = 1;
  };

  onClearNewAgent() {
    this.isLoading = false;
    this.isError = false;
  }

  *handleConfirmDelete(assistant) {
    this.isLoading = true;
    this.isConfirm = false;
    if (assistant) {
      try {
        // GraphQL removed - commented out
        // yield API.graphql({
        //   query: deleteAgent,
        //   variables: {
        //     input: {
        //       customer_id: assistant.customer_id,
        //       id: assistant.id
        //     },
        //   },
        //   authMode: 'AMAZON_COGNITO_USER_POOLS'
        // });
        // yield this.fetchAssistants();
      } catch (error) {
        this.isError = true;
      } finally {
        this.isLoading = false;
      }
    }
  }

  onDeleteConfirmation = (value) => {
    this.isConfirm = value;
  }

  onClearError = () => {
    this.isError = false;
  };


}

export default ViewAgentStore;
